// src/stores/globalError.store.ts
import { create } from 'zustand';

export type AppErrorType = 'fullScreen' | 'snackBar';

export type GlobalError =
  | null
  | {
      message: string;
      statusCode?: number;
      type: AppErrorType;
      raw?: unknown; // 필요하면 원본 에러 저장
    };

type GlobalErrorState = {
  error: GlobalError;
  setError: (err: GlobalError | { message: string; statusCode?: number; type?: AppErrorType; raw?: unknown }) => void;
  clearError: () => void;
};

export const globalErrorStore = create<GlobalErrorState>((set) => ({
  error: null,

  setError: (err) => {
    if (!err) return set({ error: null });

    // AppException 스타일로 normalize
    const normalized: GlobalError =
      'message' in err
        ? {
            message: String(err.message ?? 'Unknown error'),
            statusCode: err.statusCode,
            type: err.type ?? 'snackBar',
            raw: err.raw,
          }
        : err;

    set({ error: normalized });
  },

  clearError: () => set({ error: null }),
}));
